import React, { useState } from 'react';
import { Card, Col, Row, Button, CardGroup } from 'react-bootstrap/esm';
import PageHeader from 'components/common/PageHeader';
import blogPostList from 'data/footer/blogPostList';
import Flex from 'components/common/Flex';
const FeedBlog = () => {
 const [currentBlog, setCurrentBlog] = useState(blogPostList[0]);

 const handleClick = id => {
  setCurrentBlog(blogPostList.find(e => e.id == id));
  /*  window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    }); */ window.scrollTo(0, 0, 'smooth');
 };

 /* const RenderParagraphs = ({ text }) => {
    const paragraphs = text.split('\n');

    {
      paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>);
    }
  }; */
 return (
  <div className="container">
   {' '}
   <PageHeader title="Blog Inmovilii" description="Informacion importante del sector Finca Raiz" className="mb-3 mt-2 " />
   <Row className="bg-200">
    <Col lg={9} sm={8} className="mb-3">
     {currentBlog ? (
      <Card>
       <Card.Img height="400x" width="100px" src={currentBlog.image} />
       <Card.Body>
        <Card.Title as="h3" className="my-3 ">
         {currentBlog.title}
        </Card.Title>{' '}
        <p className="text-muted text-muted">{currentBlog.date}</p>
        {currentBlog.text.map((paragraph, i) => (
         <p key={i}>{paragraph}</p>
        ))}
       </Card.Body>
      </Card>
     ) : (
      <> nada</>
     )}
    </Col>
    <Col lg={3} xs={4} sm={4} className="mb-3 ps-0">
     {blogPostList.map(blog => (
      <CardGroup key={blog.id} className="mb-3 sticky-lg-top">
       <Card style={{ width: '20rem', height: '20rem' }}>
        <Card.Img height="130px" width="25px" src={blog.image} />
        <Card.Body className="pt-1">
         <strong className="fs--1">{blog.title}</strong>
         <br />
         <p className="fs--2 mt-2">{blog.text[0].slice(0, 115)}...</p>
         <Flex alignContent="center" wrap="wrap">
          <div className="p-2 flex-grow-1">
           <small className="text-muted">{blog.read}</small>
           <span className="ms-2 badge bg-info text-light">{blog.date}</span>
          </div>
          <div className="p-2">
           <Button className="float-end" variant="link" size="sm" onClick={() => handleClick(blog.id)}>
            <small>Leer mas...</small>
           </Button>
          </div>
         </Flex>
        </Card.Body>
       </Card>
      </CardGroup>
     ))}
    </Col>
   </Row>
  </div>
 );
};

export default FeedBlog;
